/**
 * Lo que hay que olvidar cuando cambia quién está usando la aplicación.
 *
 * POR QUÉ EXISTE. Varios módulos guardan una caché en memoria —sedes, eventos,
 * agencias— para no repetir peticiones. Esa caché es del MÓDULO, así que sobrevive
 * a un cierre de sesión: la aplicación no recarga la página al salir y entrar.
 *
 * Consecuencia real, encontrada el 2026-08-19: un super admin cargaba las 122
 * sedes, cerraba sesión, entraba una bibliotecaria en el mismo navegador y veía
 * las 122 — con el selector de residenciales abierto y su barra superior
 * mostrando "Adjuntas · Villa Valle Verde", que es la primera de la lista, no la
 * suya. El servidor rechazaba cualquier acción fuera de su alcance, pero la
 * pantalla le decía que podía. Y en un kiosco de biblioteca, donde el navegador
 * lo comparte todo el mundo, ese es el escenario normal, no el raro.
 *
 * Cada módulo con caché se registra aquí; `auth` la vacía al salir Y al entrar.
 * Al entrar también, a propósito: si alguien cerró el navegador sin salir, el
 * cierre nunca llegó a ejecutarse.
 */

const limpiadores: Array<() => void> = [];

/** Registra algo que hay que olvidar al cambiar de sesión. */
export function alCambiarDeSesion(limpiar: () => void): void {
  limpiadores.push(limpiar);
}

/**
 * Olvida el estado del usuario anterior.
 *
 * Un limpiador que falle no puede impedir que corran los demás: dejar a medias
 * este barrido es lo que produce justo la mezcla que se quiere evitar.
 */
export function limpiarEstadoDeSesion(): void {
  for (const limpiar of limpiadores) {
    try {
      limpiar();
    } catch {
      /* que uno falle no puede dejar el resto sin limpiar */
    }
  }
}
